<template>
  <el-form
    :model="formData"
    :rules="rules"
    ref="formRef"
    label-width="140px"
    class="detail-form"
  >
    <el-form-item label="应用图标" prop="icon">
      <div style="display: flex; align-items: center">
        <UploadImg
          class="upload-horizontal"
          v-model="formData.icon"
          :acceptType="['png', 'jpeg', 'jpg']"
          :limSize="2"
          :limWidth="162"
          :limHeight="162"
          @success="(file) => handleSuccessUpload(file)"
          @delete="(accessPath) => handleDeleteFile(accessPath, 'video')"
        ></UploadImg>

        <div style="color: #999; line-height: 22px; margin-left: 20px">
          <p>图标需为正方形</p>
          <p>图标大小需在200KB以内</p>
          <p>图标格式需为PNG、JPG、JPEG</p>
          <p>图标尺寸需为162*162px</p>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="应用名称" prop="appName">
      <el-input
        size="small"
        :maxlength="64"
        show-word-limit
        v-model="formData.appName"
        placeholder="请输入应用名称"
      ></el-input>
    </el-form-item>
    <el-form-item label="应用包名" prop="packageName">
      <el-input
        size="small"
        v-model="formData.packageName"
        placeholder="请输入应用包名"
      ></el-input>
    </el-form-item>
    <el-form-item label="开发者名称" prop="developerId">
      <el-select
        size="small"
        filterable
        v-model="formData.developerId"
        placeholder="请选择开发者名称"
      >
        <el-option
          v-for="item in CompanyNameList"
          :key="item.id"
          :label="`${item.developerName}`"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="应用类型" prop="apkType">
      <el-select
        size="small"
        filterable
        v-model="formData.apkType"
        placeholder="请选择应用类型"
      >
        <el-option
          v-for="item in appTypeListGp"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="归因链接" prop="gpUrl">
      <el-input
        size="small"
        v-model="formData.gpUrl"
        placeholder="请输入归因链接"
      ></el-input>
    </el-form-item>

    <el-form-item label="应用描述" prop="description">
      <el-input
        size="small"
        type="textarea"
        v-model="formData.description"
        placeholder="请输入应用描述"
      ></el-input>
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input
        size="small"
        v-model="formData.remark"
        placeholder="请输入备注"
      ></el-input>
    </el-form-item>
    <el-form-item label="是否开启推广">
      <el-switch
        v-model="formData.status"
        :active-value="1"
        :inactive-value="0"
      ></el-switch>
    </el-form-item>
    <el-form-item>
      <el-button size="small" type="primary" @click="handleSubmit()"
        >确认</el-button
      >
      <el-button size="small" @click="handleCancel()">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import UploadImg from "@/components/UploadImgGp.vue";
import { appTypeListGp } from "@/common/constant/constant.js";
export default {
  components: { UploadImg },
  props: {
    CompanyNameList: {
      type: Array,
      default() {
        return [];
      },
    },
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      appTypeListGp,
      formData: {
        icon: "",
        appName: "",
        developerId: "",
        apkType: "",
        gpUrl: "",
        packageName: "",
        description: "",
        remark: "",
        status: 0,
      },
      rules: {
        icon: [
          { required: true, message: "请上传应用图标", trigger: "change" },
        ],
        appName: [
          { required: true, message: "请输入应用名称", trigger: "blur" },
        ],
        developerId: [
          { required: true, message: "请选择开发者名称", trigger: "change" },
        ],
        apkType: [
          { required: true, message: "请选择应用类型", trigger: "change" },
        ],
        gpUrl: [{ required: true, message: "请输入归因链接", trigger: "blur" }],
        packageName: [
          { required: true, message: "请输入应用包名", trigger: "blur" },
        ],
        description: [
          { required: true, message: "请输入应用描述", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.initFormData(); // 初始化赋值
  },
  methods: {
    initFormData() {
      // 浅拷贝并过滤无效属性（可选）
      this.formData = Object.assign(
        this.formData, // 目标对象
        this.detailData // 源对象
      );
      this.$refs.formRef.clearValidate(); // 清除验证状态
    },
    handleSuccessUpload(file) {
      console.log(file);
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.formData);
        } else {
          this.$message.error("请检查输入的数据");
        }
      });
    },
    handleCancel() {
      this.$emit("cancle");
    },
    // 暴露给父组件调用刷新数据
    resetFields() {
      this.$refs.formRef.resetFields();
    },
  },
};
</script>
